<template>
    <div class="renew-page">
        <!-- 顶部工具栏：日期快捷筛选 + 搜索 + 操作按钮 -->
        <div class="header_warpper">
            <div class="left">
                <!-- 日期快捷切换标签页 -->
                <el-tabs v-model="query.type" @tab-click="handleClick" class="date-tabs">
                    <el-tab-pane label="今日" name="1"></el-tab-pane>
                    <el-tab-pane label="昨日" name="2"></el-tab-pane>
                    <el-tab-pane label="本周" name="3"></el-tab-pane>
                    <el-tab-pane label="上周" name="4"></el-tab-pane>
                </el-tabs>
                <!-- 搜索输入框 + 搜索/筛选按钮 -->
                <div class="search-group">
                    <el-input v-model="query.seek" placeholder="会员手机号/单号/备注" prefix-icon="el-icon-search" clearable class="search-input" @keyup.enter.native="searchIt"></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="searchIt">{{ $t('common.search') }}</el-button>
                    <el-button icon="el-icon-s-operation" plain @click="dialogVisible = true">{{ $t('common.filter') }}</el-button>
                </div>
            </div>

            <!-- 右侧操作区：刷新、新建、批量操作 -->
            <div class="right">
                <el-button icon="el-icon-refresh" plain @click="refush">{{ $t('common.refresh') }}</el-button>
                <el-button type="success" icon="el-icon-printer" plain @click="Print" v-if="perData.allow_print == 1">{{ $t('common.print') }}</el-button>
                <el-button type="primary" icon="el-icon-plus" v-if="perData.allow_add == 1"  @click="add">{{ $t('common.add') }}</el-button>
                <el-dropdown trigger="click" @command="handleCommand">
                    <el-button plain> 批量操作<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="1"  v-if="perData.allow_check == 1">{{ $t('common.audit') }}</el-dropdown-item>
                        <el-dropdown-item command="2"  v-if="perData.allow_checkoff == 1">反审</el-dropdown-item>
                        <el-dropdown-item command="3"  v-if="perData.allow_dele == 1">{{ $t('common.delete') }}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <!-- 数据表格区域 -->
        <div class="table-section">
            <vxe-table
                border
                stripe
                auto-resize
                :data="backData"
                ref="table"
                height="620"
                :footer-method="footerMethod"
                show-footer
                :key="refushTable"
                class="renew-table"
            >
                <!-- 复选框列（批量操作用） -->
                <vxe-table-column type="checkbox" fixed="left" width="50" align="center"></vxe-table-column>
                <!-- 序号列，表头带列配置入口 -->
                <vxe-table-column title="序号" type="seq" field="seq" fixed="left" width="50" align="center">
                    <template slot="header">
                        <i class="el-icon-setting" style="font-size: 18px" @click="changeTable"></i>
                    </template>
                </vxe-table-column>
                <!-- 动态列：根据后台列配置渲染，分三种情况 -->
                <template v-for="(item, index) in rkKeyList">
                    <!-- 情况1：普通文本列（非审核状态、非格式化字段） -->
                    <vxe-table-column
                        :key="item.field + index"
                        :field="item.field"
                        :title="item.column_name"
                        align="left"
                        :width="item.column_width"
                        v-if="item.column_status == 1 && item.field_name != '审核状态' && !formatFields.includes(item.field)"
                    >
                    </vxe-table-column>
                    <!-- 情况2：编号-名称格式化列（单据类型/银行/币别/人员等） -->
                    <vxe-table-column
                        :key="item.field + index"
                        :field="item.field"
                        :title="item.column_name"
                        align="left"
                        :width="item.column_width"
                        v-else-if="item.column_status == 1 && formatFields.includes(item.field)"
                    >
                        <template #default="{ row }">
                            {{ formatNoName(row[item.field], item.field) }}
                        </template>
                    </vxe-table-column>
                    <!-- 情况3：审核状态列，用标签显示 -->
                    <vxe-table-column
                        :key="item.field + index"
                        :field="item.field"
                        :title="item.column_name"
                        :width="item.column_width"
                        v-else-if="item.field_name == '审核状态' && item.column_status == 1"
                    >
                        <template #default="{ row }">
                            <el-tag :type="row.check == 1 ? 'success' : 'danger'">{{ row.check == 1 ? $t('common.audited') : $t('common.notAudited') }}</el-tag>
                        </template>
                    </vxe-table-column>
                </template>
                <!-- 操作列：编辑/删除/审核（已审核记录禁止编辑和删除） -->
                <vxe-table-column title="操作" field="" fixed="right" width="210" align="center">
                    <template #default="{ row }">
                        <el-button size="mini" type="primary" plain :disabled="row.check == 1" @click="Edit(row)"  v-if="perData.allow_edit == 1">{{ $t('common.edit') }}</el-button>
                        <el-button size="mini" type="danger" plain :disabled="row.check == 1" @click="deleteIt(row)"  v-if="perData.allow_dele == 1">{{ $t('common.delete') }}</el-button>
                        <el-button size="mini" type="warning" plain @click="Check(row)"   v-if="perData.allow_check == 1">{{ row.check == '1' ? '反审' : '审核' }}</el-button>
                    </template>
                </vxe-table-column>
                <template #empty>
                    <span style="color: red">
                        <img src="@/assets/img/dontHave.png" style="width: 180px" />
                    </span>
                </template>
            </vxe-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,sizes, prev, pager, next"
                    :current-page="query.page"
                    :page-size="query.page_size"
                    :page-sizes="[10, 50, 200, 500]"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>
        <!-- 新建/编辑抽屉表单（已审核记录禁止修改） -->
        <el-drawer :visible.sync="drawer" direction="rtl" size="680px" :with-header="false">
            <div class="form-drawer">
                <!-- 抽屉头部 -->
                <div class="form-drawer__header">
                    <div class="header-title">
                        <i :class="isAdd ? 'el-icon-plus' : 'el-icon-edit'"></i>
                        <span>{{ isAdd ? '新建续费单' : '编辑续费单' }}</span>
                    </div>
                    <i class="el-icon-close header-close" @click="drawer = false"></i>
                </div>
                <!-- 表单主体 -->
                <div class="form-drawer__body">
                    <el-form :model="form" ref="from" :rules="rules" label-width="88px" label-position="right">
                        <!-- 会员信息分组 -->
                        <div class="form-section">
                            <div class="section-title"><i class="el-icon-user"></i>会员信息</div>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="手机号" prop="phone">
                                        <el-input v-model="form.phone" placeholder="输入后回车查询" @blur="getMemberData" @keyup.enter.native="getMemberData">
                                            <i slot="suffix" class="el-icon-search" style="cursor:pointer" @click="getMemberData"></i>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="会员ID">
                                        <el-input v-model="form.member_id" disabled placeholder="自动带出"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="会员名称">
                                        <el-input v-model="form.member_name" disabled placeholder="自动带出"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="客户" prop="cust_no">
                                        <el-select v-model="form.cust_no" filterable default-first-option clearable placeholder="自动带出" style="width: 100%" @change="onCustChange">
                                            <el-option v-for="(item, index) in pullData.cust" :key="index" :label="item.cust_no + ' - ' + item.cust_name" :value="item.cust_no.toString()" :disabled="item.status == 0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <!-- 单据信息分组 -->
                        <div class="form-section">
                            <div class="section-title"><i class="el-icon-document"></i>单据信息</div>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item :label="$t('common.billNo')" required>
                                        <el-input v-model="form.bill_no" disabled placeholder="系统自动生成"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="日期" prop="bill_date">
                                        <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" v-model="form.bill_date" style="width: 100%"></el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item :label="$t('common.billType')" prop="billtype_no">
                                        <el-select v-model="form.billtype_no" filterable default-first-option clearable placeholder="请选择" style="width: 100%">
                                            <el-option v-for="(item, index) in pullData.billtype" :key="index" :label="item.billtype_no + ' - ' + item.billtype_name" :value="item.billtype_no.toString()" :disabled="item.status == 0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="收款银行" prop="bank_no">
                                        <el-select v-model="form.bank_no" filterable default-first-option clearable placeholder="请选择" style="width: 100%">
                                            <el-option v-for="(item, index) in pullData.bank" :key="index" :label="item.bank_no + ' - ' + item.bank_name" :value="item.bank_no.toString()" :disabled="item.status == 0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item :label="$t('common.currency')" prop="currency_no">
                                        <el-select v-model="form.currency_no" filterable default-first-option clearable placeholder="请选择" style="width: 100%">
                                            <el-option v-for="(item, index) in pullData.currency" :key="index" :label="item.currency_no + ' - ' + item.currency_name" :value="item.currency_no.toString()" :disabled="item.status == 0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="金额" prop="amt">
                                        <el-input v-model="form.amt" min="0" type="number" @blur="$vaildator.amt(form)" placeholder="请输入"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item v-if="systemSet.isstores == 1"  :label="$t('common.store')">
                                        <mySelect v-model="form.store_no" :options="pullData.store" values="store_no" labels="store_name" keys="store_no" :clearables="false" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <!-- 续费信息分组 -->
                        <div class="form-section">
                            <div class="section-title"><i class="el-icon-refresh"></i>续费信息</div>
                            <el-row :gutter="20">
                                <el-col :span="24">
                                    <el-form-item label="续费时长" prop="duration_days">
                                        <el-input v-model="form.duration_days" min="0" type="number" placeholder="请输入天数" @input="calcValidTo">
                                            <template slot="append">天</template>
                                        </el-input>
                                        <!-- 快捷选择常见续费周期 -->
                                        <div class="duration-shortcuts">
                                            <span
                                                v-for="item in durationOptions"
                                                :key="item.days"
                                                class="shortcut-tag"
                                                :class="{ active: form.duration_days == item.days }"
                                                @click="setDuration(item.days)"
                                            >
                                                <i class="el-icon-time"></i>
                                                <em>{{ item.label }}</em>
                                            </span>
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="有效期从" prop="valid_from">
                                        <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="起始时间" v-model="form.valid_from" style="width: 100%"></el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="有效期至" prop="valid_to">
                                        <el-date-picker type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间" v-model="form.valid_to" style="width: 100%"></el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24" class="valid-hint-row">
                                    <span class="valid-hint"><i class="el-icon-info"></i>有效期格式：年-月-日 时:分:秒，选择后自动计算</span>
                                </el-col>
                            </el-row>
                        </div>
                        <!-- 备注 -->
                        <div class="form-section form-section--last">
                            <el-form-item :label="$t('common.remark')">
                                <el-input type="textarea" :rows="3" v-model="form.remark" placeholder="可选填写备注信息"></el-input>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <!-- 底部操作栏 -->
                <div class="form-drawer__footer">
                    <el-button @click="drawer = false">取 消</el-button>
                    <el-button type="primary" icon="el-icon-check" @click="addIt">确认提交</el-button>
                </div>
            </div>
        </el-drawer>
        <!-- 筛选条件弹窗：日期/单据类型/审核状态/收款帐户/币别/人员 -->
        <el-dialog :title="$t('common.filter')" :visible.sync="dialogVisible" width="30%">
            <div class="dialog">
                <div style="margin-top: 20px" class="block">
                    <p>日期</p>
                    <el-radio-group v-model="query.type" size="medium">
                        <el-radio-button label="1">今日</el-radio-button>
                        <el-radio-button label="2">昨日</el-radio-button>
                        <el-radio-button label="3">本周</el-radio-button>
                        <el-radio-button label="4">上周</el-radio-button>
                        <el-radio-button label="5">本月</el-radio-button>
                        <el-radio-button label="6">上月</el-radio-button>
                    </el-radio-group>
                </div>

                <div class="block">
                    <p class="demonstration">自定义</p>
                    <el-date-picker
                        v-model="value2"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right"
                        style="width: 80%"
                        @change="changeDate"
                        value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                </div>
                <div class="block">
                    <p class="demonstration">{{ $t('common.billType') }}</p>
                    <el-select
                        v-model="query.billtype_no"
                        filterable
                        default-first-option
                        clearable
                        placeholder="请选择"
                        style="width: 80%"
                    >
                        <el-option
                            v-for="(item, index) in pullData.billtype"
                            :key="index"
                            :label="item.billtype_no + ' - ' + item.billtype_name"
                            :value="item.billtype_no.toString()"
                            :disabled="item.status == 0"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="block">
                    <p>{{ $t('common.auditStatus') }}</p>
                    <el-radio-group v-model="query.check">
                        <el-radio label="0">{{ $t('common.all') }}</el-radio>
                        <el-radio label="未审核">未审核</el-radio>
                        <el-radio label="已审核">已审核</el-radio>
                    </el-radio-group>
                </div>
                <div class="block">
                    <p class="demonstration">收款帐户</p>
                    <el-select v-model="query.bank_no" filterable default-first-option clearable placeholder="请选择" style="width: 80%">
                        <el-option
                            v-for="(item, index) in pullData.bank"
                            :key="index"
                            :label="item.bank_no + ' - ' + item.bank_name"
                            :value="item.bank_no.toString()"
                            :disabled="item.status == 0"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="block">
                    <p class="demonstration">币别</p>
                    <el-select
                        v-model="query.currency_no"
                        filterable
                        default-first-option
                        clearable
                        placeholder="请选择"
                        style="width: 80%"
                    >
                        <el-option
                            v-for="(item, index) in pullData.currency"
                            :key="index"
                            :label="item.currency_no + ' - ' + item.currency_name"
                            :value="item.currency_no.toString()"
                            :disabled="item.status == 0"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="block">
                    <p class="demonstration">建单人</p>
                    <el-select v-model="query.build_no" filterable default-first-option clearable placeholder="请选择" style="width: 80%">
                        <el-option
                            v-for="(item, index) in pullData.staff"
                            :key="index"
                            :label="item.staff_no + ' - ' + item.staff_name"
                            :value="item.staff_no"
                            :disabled="item.status == 0"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="block">
                    <p class="demonstration">{{ $t('common.modifier') }}</p>
                    <el-select v-model="query.modify_no" filterable default-first-option clearable placeholder="请选择" style="width: 80%">
                        <el-option
                            v-for="(item, index) in pullData.staff"
                            :key="index"
                            :label="item.staff_no + ' - ' + item.staff_name"
                            :value="item.staff_no"
                            :disabled="item.status == 0"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="screen">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 列表配置抽屉：拖拽排序、显示/隐藏字段 -->
        <el-drawer title="列配置" :visible.sync="drawers" direction="rtl" :with-header="false">
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index" @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost" :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2" v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm') }}</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
// 会员续费管理相关接口
import {
    apiPrintMemberRenew, // 打印
    apiGetDataMemberManage, // 根据手机号查询会员信息
    apiGetMemberRenewList, // 获取续费单列表
    apiPullMemberRenew, // 获取下拉框数据（单据类型/银行/币别/门店/人员/客户）
    apiAddMemberRenew, // 新增续费单
    apiUpdateMemberRenew, // 修改续费单
    apiDeleteMemberRenew, // 删除续费单
    apiCheckMemberRenew, // 单条审核/反审
    apiCheckAllMemberRenew, // 批量审核/反审
    apiGetListCorrespondingData, // 获取表格列配置
    apiUpdateListCorrespondingData, // 保存表格列配置
    apiCurrentPermisson // 获取权限
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n'; // 列名多语言转换工具
export default {
    name: 'memberRenewManage', // 组件名，供 keep-alive 缓存页面状态（切换页面不丢失筛选条件）
    data() {
        return {
            perData: {},//权限数据
            // 查询参数
            query: {
                page: 1, // 当前页码
                page_size: 10, // 每页条数
                seek: '', // 搜索关键字（单号/备注）
                type: '1', // 日期类型：1今日 2昨日 3本周 4上周 5本月 6上月
                begin_date: '', // 查询起始日期
                end_date: '', // 查询截止日期
                check: '0' // 审核状态筛选：0全部
            },
            pageTotal: 0, // 数据总条数
            backData: [], // 表格数据
            drawer: false, // 新建/编辑抽屉显示状态
            form: { bill_date: '' }, // 表单数据
            pullData: {}, // 下拉框数据集合
            // 需要编号-名称格式化显示的字段
            formatFields: ['billtype_no', 'bank_no', 'currency_no', 'build_no', 'modify_no', 'check_no', 'cust_no'],
            // 续费时长快捷选项
            durationOptions: [
                { label: '1个月', days: 30 },
                { label: '3个月', days: 90 },
                { label: '半年', days: 180 },
                { label: '1年', days: 365 },
                { label: '2年', days: 730 },
                { label: '3年', days: 1095 }
            ],
            // 表单验证规则
            rules: {
                bill_date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
                billtype_no: [{ required: true, message: '请选择单据类型', trigger: 'blur' }],
                bank_no: [{ required: true, message: '请选择收款账户', trigger: 'blur' }],
                currency_no: [{ required: true, message: '请选择币别', trigger: 'blur' }],
                amt: [{ required: true, message: '请选择金额', trigger: 'blur' }]
            },
            isAdd: true, // 是否为新建模式（true=新建，false=编辑）
            dialogVisible: false, // 筛选弹窗显示状态
            value2: '', // 自定义日期范围
            systemSet: '', // 系统设置（小数位数等）

            // === 列配置相关 ===
            rkKeyList: [], // 当前显示的列配置（已转换语言）
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            keyList: [], // 列配置编辑副本
            drawers: false, // 列配置抽屉显示状态
            showIndex: null, // 已显示字段悬停索引
            optionalIndex: null, // 可选字段悬停索引
            refushTable: true // 表格强制刷新key
        };
    },
    mounted() {
        // 初始化系统设置（金额小数位等）
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));

        // 处理传入的 bill_no 参数
        if (this.$route.query.bill_no) {
            this.query.seek = this.$route.query.bill_no;
        }

        // 初始化加载：获取权限 → 计算日期范围 → 获取列表 → 获取下拉数据 → 获取列配置
        this.getPermission();
        this.calcDateRange();
        this.getData();
        this.getPull();
        this.getTable();

        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    methods: {
        // ==================== 获取权限 ====================
        // 获取权限
        getPermission() {
            apiCurrentPermisson({
                id: '224'
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // ==================== 数据查询 ====================

        // 获取续费单列表数据
        getData() {
            let params = { ...this.query };
            delete params.type; // type仅用于前端计算日期，不传给后台
            apiGetMemberRenewList(params).then((res) => {
                this.backData = res.data.data;
                this.pageTotal = res.data.count;
            });
        },
        // ==================== 日期计算 ====================

        // 数字补零（1→'01'）
        pad(n) {
            return n < 10 ? '0' + n : '' + n;
        },
        // 根据日期类型计算begin_date和end_date
        calcDateRange() {
            var now = new Date();
            var year = now.getFullYear();
            var month = now.getMonth();
            var date = now.getDate();
            var day = now.getDay() === 0 ? 7 : now.getDay();
            var beginDate, endDate;
            switch (this.query.type) {
                case '1': // 今日
                    beginDate = new Date(year, month, date);
                    endDate = new Date(year, month, date);
                    break;
                case '2': // 昨日
                    beginDate = new Date(year, month, date - 1);
                    endDate = new Date(year, month, date - 1);
                    break;
                case '3': // 本周
                    beginDate = new Date(year, month, date - day + 1);
                    endDate = new Date(year, month, date - day + 7);
                    break;
                case '4': // 上周
                    beginDate = new Date(year, month, date - day - 6);
                    endDate = new Date(year, month, date - day);
                    break;
                case '5': // 本月
                    beginDate = new Date(year, month, 1);
                    endDate = new Date(year, month + 1, 0);
                    break;
                case '6': // 上月
                    beginDate = new Date(year, month - 1, 1);
                    endDate = new Date(year, month, 0);
                    break;
                default:
                    return;
            }
            var pad = this.pad;
            this.query.begin_date = beginDate.getFullYear() + '-' + pad(beginDate.getMonth() + 1) + '-' + pad(beginDate.getDate()) + ' 00:00:00';
            this.query.end_date = endDate.getFullYear() + '-' + pad(endDate.getMonth() + 1) + '-' + pad(endDate.getDate()) + ' 23:59:59';
        },
        // ==================== 会员信息查询与有效期计算 ====================

        // 根据手机号获取会员信息，并自动填充会员ID/名称/客户/有效期起始时间
        getMemberData(type) {
            const data =
                type === 'cust'
                    ? { cust_no: this.form.cust_no, bill_date: this.form.bill_date }
                    : { phone: this.form.phone, bill_date: this.form.bill_date };
            // 查询条件为空时不发起请求
            if (!data.cust_no && !data.phone) {
                return;
            }
            apiGetDataMemberManage(data).then((res) => {
                if (res.code == 2000 && res.data) {
                    this.$set(this.form, 'phone', res.data.phone);
                    this.$set(this.form, 'member_id', res.data.id);
                    this.$set(this.form, 'member_name', res.data.name);
                    // 带出客户（按客户查询时不覆盖用户已选择的客户）
                    if (type !== 'cust') {
                        this.$set(this.form, 'cust_no', res.data.cust_no);
                    }
                    // 根据到期日期计算有效期起始时间
                    var beginDate;
                    if (!res.data.expire_date) {
                        // 到期日期为空，有效期起始时间为今天
                        beginDate = new Date();
                    } else {
                        // 到期日期不为空，加一天
                        beginDate = new Date(res.data.expire_date.replace(/-/g, '/'));
                        beginDate.setDate(beginDate.getDate() + 1);
                    }
                    var validFrom = beginDate.getFullYear() + '-' + this.pad(beginDate.getMonth() + 1) + '-' + this.pad(beginDate.getDate()) + ' 00:00:00';
                    this.$set(this.form, 'valid_from', validFrom);
                    this.calcValidTo();
                } else {
                    this.$set(this.form, 'member_id', '');
                    this.$set(this.form, 'member_name', '');
                    this.$message.warning('未查询到该会员信息');
                }
            });
        },
        // 选择客户后根据客户编号查询会员信息
        onCustChange(value) {
            if (!value) return;
            this.getMemberData('cust');
        },
        // 根据有效期起始时间和续费时长计算有效期结束时间
        calcValidTo() {
            if (!this.form.valid_from || !this.form.duration_days) return;
            var begin = new Date(this.form.valid_from.replace(/-/g, '/'));
            var days = parseInt(this.form.duration_days);
            if (isNaN(days) || days <= 0) return;
            var end = new Date(begin.getTime() + (days - 1) * 24 * 60 * 60 * 1000);
            this.$set(this.form, 'valid_to', end.getFullYear() + '-' + this.pad(end.getMonth() + 1) + '-' + this.pad(end.getDate()) + ' 23:59:59');
        },
        // 快捷设置续费时长并自动计算结束时间
        setDuration(days) {
            this.$set(this.form, 'duration_days', String(days));
            this.calcValidTo();
        },
        // ==================== 下拉数据 ====================

        // 获取所有下拉框数据（单据类型/银行/币别/门店/人员/客户）
        getPull() {
            apiPullMemberRenew().then((res) => {
                this.pullData = res.data;
            });
        },
        // ==================== 表格列格式化 ====================

        // 编号-名称格式化显示（将编号转为“编号 - 名称”格式）
        formatNoName(value, field) {
            if (!value) return '';
            var map = {
                billtype_no: { list: this.pullData.billtype, no: 'billtype_no', name: 'billtype_name' },
                bank_no: { list: this.pullData.bank, no: 'bank_no', name: 'bank_name' },
                cust_no: { list: this.pullData.cust, no: 'cust_no', name: 'cust_name' },
                currency_no: { list: this.pullData.currency, no: 'currency_no', name: 'currency_name' },
                build_no: { list: this.pullData.staff, no: 'staff_no', name: 'staff_name' },
                modify_no: { list: this.pullData.staff, no: 'staff_no', name: 'staff_name' },
                check_no: { list: this.pullData.staff, no: 'staff_no', name: 'staff_name' }
            };
            var config = map[field];
            if (!config || !config.list) return value;
            var item = config.list.find(function (i) {
                return String(i[config.no]) === String(value);
            });
            return item ? value + ' - ' + item[config.name] : value;
        },
        // 自定义日期范围变化回调
        changeDate(value) {
            if (value) {
                this.query.type = '';
                this.query.begin_date = value[0] + ' 00:00:00';
                this.query.end_date = value[1] + ' 23:59:59';
            } else {
                this.query.type = '1';
                this.calcDateRange();
            }
        },

        // ==================== 列配置管理 ====================

        // 获取后台列配置数据
        getTable() {
            apiGetListCorrespondingData({
                id: '139'
            }).then((res) => {
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        // 打开列配置抽屉
        changeTable() {
            this.drawers = true;
            this.keyList = this.rkKeyList.map((item) => item);
        },
        // 列显示/隐藏切换
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        // 拖拽移动校验（允许所有拖拽）
        checkMove() {},
        // 取消列配置，重新加载原始配置
        keycancel() {
            this.drawers = false;
            this.getTable();
        },
        // 确认保存列配置
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: '139'
            }).then((res) => {
                this.drawers = false;
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // ==================== 搜索与筛选 ====================

        // 筛选确认
        screen() {
            this.dialogVisible = false;
            if (this.query.type) {
                this.calcDateRange();
            }
            this.getData();
        },
        // 切换日期搜素
        handleClick(tab, event) {
            this.calcDateRange();
            this.getData();
        },
        // 搜索
        searchIt() {
            this.getData();
        },
        // ==================== 批量操作 ====================

        // 批量操作命令分发：1=审核 2=反审 3=删除
        handleCommand(command) {
            if (command == 1 || command == 2) {
                this.check(command);
            } else if (command == 3) {
                this.deleteIts();
            }
        },
        // 批量删除（已审核记录不允许删除，自动过滤）
        deleteIts() {
            let data = this.$refs.table.getCheckboxRecords();
            if (data.length == 0) {
                this.$message.warning('请选择需要操作的数据');
                return;
            }
            // 过滤掉已审核的记录
            let filtered = data.filter((item) => item.check != 1);
            if (filtered.length == 0) {
                this.$message.warning('所选数据均已审核，无法删除');
                return;
            }
            if (filtered.length < data.length) {
                this.$message.warning('已自动跳过已审核的记录');
            }
            let idArr = [];
            filtered.forEach((item) => {
                idArr.push(item.id);
            });
            let ids = idArr.join(',');
            this.$confirm('确定要删除该会员续费单吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apiDeleteMemberRenew({
                        id: ids
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 批量审核/反审（command: 1=审核 2=反审）
        check(command) {
            let check;
            if (command == 1) {
                check = 1;
            } else if (command == 2) {
                check = 0;
            }
            let data = this.$refs.table.getCheckboxRecords();
            if (data.length == 0) {
                this.$message.warning('请选择需要操作的数据');
                return;
            }

            let idArr = [];
            data.forEach((item) => {
                idArr.push(item.id);
            });
            let ids = idArr.join(',');
            apiCheckAllMemberRenew({
                check: check,
                id: ids
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // ==================== 新建/编辑/删除/审核 ====================

        // 新建续费单：初始化表单并设置下拉默认值
        add() {
            this.form = {};
            this.isAdd = true;
            this.drawer = true;
            this.$set(this.form, 'bill_date', this.$getTime());
            const keys = Object.keys(this.pullData);
            const formKeys = keys.map((key) => `${key}_no`);
            keys.forEach((key, index) => {
                if (Array.isArray(this.pullData[key])) {
                    // 确保 this.pullData[key] 是一个数组，而不是 undefined 或 null
                    const defaultItem = this.pullData[key].find((item) => item.isdefault == 1);
                    if (defaultItem) {
                        // 确保 defaultItem 和属性 formKeys[index] 存在
                        if (defaultItem.hasOwnProperty(formKeys[index])) {
                            this.$set(this.form, formKeys[index], String(defaultItem[formKeys[index]]));
                        } else {
                            console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                            this.$set(this.form, formKeys[index], ''); // 如果属性不存在，给它赋个默认值
                        }
                    } else {
                        // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                        console.warn(`No defaultItem found for key ${key}`);
                        this.$set(this.form, formKeys[index], '');
                    }
                } else {
                    // 如果 this.pullData[key] 不是一个数组，输出警告
                    console.warn(`Expected an array for key ${key}, but found ${typeof this.pullData[key]}`);
                }
            });
        },
        // 提交表单（新增或修改，已审核记录禁止保存）
        addIt() {
            // 已审核记录不允许修改保存
            if (!this.isAdd && this.form.check == 1) {
                this.$message.warning('该记录已审核，不允许修改');
                return;
            }
            this.$refs.from.validate((valid) => {
                if (!valid) return false;
                var apiFn = this.isAdd ? apiAddMemberRenew : apiUpdateMemberRenew;
                this.$load.show();
                apiFn({ ...this.form }).then((res) => {
                    this.$load.close();
                    if (res.code == 2000) {
                        this.$message.success(res.msg);
                        this.drawer = false;
                        this.getData();
                    } else {
                        this.$message.error(res.data.info);
                    }
                });
            });
        },
        // 编辑续费单（已审核记录禁止编辑）
        Edit(row) {
            if (row.check == 1) {
                this.$message.warning('该记录已审核，不允许编辑');
                return;
            }
            this.form = Object.assign({}, row);
            this.isAdd = false;
            this.drawer = true;
        },
        // 删除单条续费单（已审核记录禁止删除）
        deleteIt(row) {
            if (row.check == 1) {
                this.$message.warning('该记录已审核，不允许删除');
                return;
            }
            this.$confirm('确定要删除该会员续费单吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    apiDeleteMemberRenew({
                        id: row.id
                    }).then((res) => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },
        // 打印
        Print() {
            let data = this.$refs.table.getCheckboxRecords();
            if (data.length == 0) {
                this.$message.warning('请选择需要操作的数据');
                return;
            }

            let idArr = [];
            data.forEach((item) => {
                idArr.push(item.id);
            });

            apiPrintMemberRenew({ id: idArr }).then((res) => {
                if (res.code == 2000) {
                    this.$router.push({
                        path: '/printingfusion',
                        query: {
                            url: res.data.Url
                        }
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });

        },
        // 单条审核/反审切换
        Check(row) {
            let check;
            if (row.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apiCheckMemberRenew({
                id: row.id,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 刷新：重置查询条件并重新加载
        refush() {
            this.query = {
                page: 1,
                page_size: 10,
                seek: '',
                type: '1',
                begin_date: '',
                end_date: '',
                check: '0'
            };
            this.calcDateRange();
            this.getData();
        },
        // 表尾合计
        footerMethod({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 1) {
                        return '合计';
                    } else if (column.property == 'amt') {
                        return `${this.$utils.sum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        // 分页导航
        handlePageChange(val) {
            this.query.page = val;
            this.getData();
        },
        pageSizeChange(val) {
            this.query.page_size = val;
            this.getData();
        }
    }
};
</script>

<style scoped lang="scss">
.renew-page {
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 4px;
}
.header_warpper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 14px;
    border-bottom: 1px solid #f0f2f5;
    margin-bottom: 14px;
    .left {
        display: flex;
        align-items: center;
    }
    .search-group {
        display: flex;
        align-items: center;
        margin-left: 40px;
        .search-input {
            width: 200px;
            margin-right: 10px;
        }
        .el-button + .el-button {
            margin-left: 10px;
        }
    }
    .right {
        display: flex;
        align-items: center;
        .el-button + .el-button,
        .el-dropdown {
            margin-left: 10px;
        }
    }
}
.date-tabs {
    margin-right: 10px;
}
/deep/.el-tabs__nav-wrap::after {
    background-color: transparent;
}
/deep/.el-tabs__item {
    width: 72px;
    text-align: center;
    padding: 0;
    font-size: 14px;
}
/deep/.el-tabs__active-bar {
    width: 72px !important;
}
/deep/.el-tabs__header {
    margin-bottom: 0;
}
.table-section {
    .renew-table {
        /deep/.vxe-header--column {
            background-color: #f5f7fa;
            font-weight: 600;
            color: #333;
        }
        /deep/.vxe-body--row {
            &:hover {
                td {
                    background-color: #ecf5ff !important;
                }
            }
        }
    }
}
.pagination {
    text-align: right;
    padding: 14px 0 4px;
}
// ==================== 新建/编辑抽屉表单 ====================
/deep/.el-drawer__body {
    padding: 0;
    overflow: hidden;
}
.form-drawer {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #f5f7fa;
}
.form-drawer__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 24px;
    background: linear-gradient(135deg, #409eff 0%, #53a8ff 100%);
    flex-shrink: 0;
    .header-title {
        display: flex;
        align-items: center;
        gap: 10px;
        color: #fff;
        font-size: 17px;
        font-weight: 600;
        i {
            font-size: 20px;
        }
    }
    .header-close {
        color: rgba(255, 255, 255, 0.85);
        font-size: 20px;
        cursor: pointer;
        transition: all 0.2s;
        &:hover {
            color: #fff;
            transform: rotate(90deg);
        }
    }
}
.form-drawer__body {
    flex: 1;
    overflow-y: auto;
    padding: 20px 28px;
}
.form-drawer__footer {
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 14px 24px;
    background: #fff;
    border-top: 1px solid #ebeef5;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
}
// 表单分组卡片
.form-section {
    background: #fff;
    border-radius: 8px;
    padding: 20px 24px 4px;
    margin-bottom: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
    &--last {
        padding-bottom: 20px;
        margin-bottom: 0;
    }
    .section-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 18px;
        padding-bottom: 12px;
        border-bottom: 1px solid #f2f3f5;
        i {
            font-size: 16px;
            color: #409eff;
        }
    }
    /deep/.el-form-item__label {
        font-weight: 500;
        color: #606266;
    }
    /deep/.el-date-editor {
        width: 100% !important;
    }
    /deep/.el-input__inner {
        padding-right: 30px;
    }
}
// 有效期提示行
.valid-hint-row {
    margin-top: -8px;
    margin-bottom: 12px;
    .valid-hint {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        font-size: 12px;
        color: #909399;
        i {
            color: #c0c4cc;
        }
    }
}
.dialog {
    .block {
        display: flex;
        align-items: center;
        margin-bottom: 22px;
        p {
            display: inline-block;
            width: 88px;
            color: #606266;
            font-weight: 500;
            flex-shrink: 0;
        }
    }
}
// 续费时长快捷选择按钮组
.duration-shortcuts {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 10px;
    .shortcut-tag {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 4px 12px;
        font-size: 12px;
        line-height: 20px;
        border: 1px solid #e4e7ed;
        border-radius: 14px;
        color: #606266;
        background: #f8f9fb;
        cursor: pointer;
        transition: all 0.25s ease;
        user-select: none;
        i {
            font-size: 13px;
            color: #909399;
            transition: color 0.25s ease;
        }
        em {
            font-style: normal;
            font-weight: 500;
        }
        &:hover {
            color: #409eff;
            border-color: #b3d8ff;
            background: #ecf5ff;
            box-shadow: 0 2px 6px rgba(64, 158, 255, 0.15);
            transform: translateY(-1px);
            i {
                color: #409eff;
            }
        }
        &.active {
            color: #fff;
            background: linear-gradient(135deg, #409eff, #66b1ff);
            border-color: transparent;
            box-shadow: 0 2px 8px rgba(64, 158, 255, 0.35);
            i {
                color: #fff;
            }
        }
    }
}
</style>
